import React, {Component} from 'react';
import {Route, Switch, withRouter, Redirect} from 'react-router-dom';
import { connect } from 'react-redux';
import Pusher from 'pusher-js';
import { updateObject } from '../../global/utility';

import * as billboardActions from '../actions/index';
import * as userActions from '../../global/user/actions/index';

import LoadingIndicator from '../../global/loading_indicator/loading_indicator';
import Button from '../../global/button/button';
import TextField from '../../global/text_field/text_field';
import MediaGridView from '../../global/grid_view/media_grid_view';
import MediaUploadButton from '../media_upload_button/media_upload_button';
import logger from '../../global/logger';

class BillboardMediaLibraryView extends Component {

    state = {
        page_message: "",
        messages: [],
    }

    componentDidMount() {
        
    }

    componentWillUnmount() {
        
    }

    componentDidUpdate(prevProps) {
        
    }

    changeHandler(event, property_name) {
        
        this.setState(updateObject(this.state, {page_message: event.target.value}));
        logger.log("message: " + this.state.page_message);
    }

    uploadMedia(file) {
        this.props.onUploadMedia(file, this.props.selected_playlist.id, () => {
            this.props.onFetchMedia();
        });
    }

    onSave(item, callback) {
        logger.log("onSave: " + item);
        this.props.onSaveMedia(item, () => {
            this.props.onFetchMedia(callback);
        });
    }

    onDelete(item, callback) {
        logger.log("onDelete: " + item);
        this.props.onDeleteMedia(item.id, callback);
    }

    render () {

        let content = (
            <div>
                <p className="text-gray-500 text-xl mb-2">Media Library</p>
                
                <MediaUploadButton id="upload_button" text="Upload Media" onUploadMedia={(file) => this.uploadMedia(file)} />
                
                <div className="clear-both" />

                <br />

                <MediaGridView items={this.props.media} onSave={(item, callback) => this.onSave(item, callback)} onDelete={(item, callback) => this.onDelete(item, callback)} />
            </div>
        );

        if (this.props.loading_media) {
            content = (
                <LoadingIndicator />
            )
        }

        return content;
    }
}

const mapStateToProps = state => {
    return {
        loading_playlists: state.billboard.loading_playlists,
        playlists: state.billboard.playlists,
        selected_playlist: state.billboard.selected_playlist,
        media: state.billboard.media,
        selected_media: state.billboard.selected_media,
        loading_media: state.billboard.loading_media,
        saving_media: state.billboard.saving_media,
        deleting_media: state.billboard.deleting_media,
    };
}

const mapDispatchToProps = dispatch => {
    return {
        onFetchPlaylists: (callback) => dispatch(billboardActions.fetchPlaylists(callback)),
        onUpdateAuthToken: (callback) => dispatch(userActions.updateAuthToken(callback)),
        onFetchMedia: (callback) => dispatch(billboardActions.fetchMedia(callback)),
        onSelectMedia: (media) => dispatch(billboardActions.selectMedia(media)),
        onUploadMedia: (media, playlist_id, callback) => dispatch(billboardActions.uploadMedia(media, playlist_id, callback)),
        onSaveMedia: (media, callback) => dispatch(billboardActions.saveMedia(media, callback)),
        onDeleteMedia: (media_id, callback) => dispatch(billboardActions.deleteMedia(media_id, callback)),
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BillboardMediaLibraryView));